import { twMerge } from "tailwind-merge";
import { Loader } from "@shared/ui/Loader";
import { Dialog } from "@shared/ui/Dialog";
import { Type } from "@shared/ui/Type";
import formatDateToString from "@shared/utils/formatDateToString";
import { ProgramUserInvitation } from "@platform/types/dashboard.types";
import {
  deletionTitle,
  deletionDescription,
} from "../../friendInvitation.data";
import useFriendInvitationDelete from "../../hooks/useFriendInvitationDelete";

type Props = {
  onDone: () => Promise<void>;
  onClose: () => void;
  isOpen: boolean;
  invitation: ProgramUserInvitation;
  programId: number;
};

export function FriendInvitationDeletionDialog({
  onDone,
  onClose,
  isOpen,
  invitation,
  programId,
}: Props) {
  const { mutateAsync: deleteInvitation, isPending } =
    useFriendInvitationDelete({
      programId,
      onDone,
    });

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={deletionTitle}
      description={deletionDescription}
      primaryButtonText={"Delete Invitation"}
      onPrimaryClick={deleteInvitation}
      onSecondaryClick={onClose}
      secondaryButtonText={"Cancel"}
      primaryButtonProps={{
        destructive: true,
        disabled: isPending,
      }}
      secondaryButtonProps={{
        disabled: isPending,
      }}
    >
      {isPending && <Loader isAbsolute />}
      <div
        className={twMerge(
          "bg-brand-50 p-5 rounded-lg border border-brand-800 flex flex-col gap-1",
          isPending && "opacity-20"
        )}
      >
        <Type variant="h5">{invitation.invited_email}</Type>
        <Type variant="caption">
          Invited on {formatDateToString(invitation.created_at?.toString())}
        </Type>
        <Type variant="caption">
          Invite expires {formatDateToString(invitation.expires_at?.toString())}
        </Type>
      </div>
    </Dialog>
  );
}

export default FriendInvitationDeletionDialog;
